import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, CancelTransactionDialogueHandler } from '../types';
import CancelTransactionDialogueContext from './CancelTransactionContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type CancelTransactionDialogueProps = {
  handleDialogue: DialogueHandler<CancelTransactionDialogueHandler>;
};

type FC = FunctionComponent<CancelTransactionDialogueProps>;

const CancelTransactionDialogue: FC = ({ handleDialogue }: CancelTransactionDialogueProps) => {
  const { showCancelTransactionConfirmAlert, showCancelTransactionErrorAlert, sendCancelTransactionError } = useContext(
    CancelTransactionDialogueContext,
  );
  const { t } = useTranslation('translations', { keyPrefix: 'ClientAccounts.Schedule.Details.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Transaction Cancel Confirmation */}
        <ConfirmationDialogue
          isVisible={showCancelTransactionConfirmAlert}
          title={t('TransactionCancelConfirmation.title')}
          status="alert"
          subTitle=""
          confirm={{
            label: t('TransactionCancelConfirmation.confirmButton'),
            action: () => handleDialogue({ type: 'alert', state: 'confirm' }),
          }}
          cancel={{
            label: t('TransactionCancelConfirmation.cancelButton'),
            action: () => handleDialogue({ type: 'alert', state: 'fail' }),
          }}
        />
        {/* Transaction Cancel Error */}
        <ConfirmationDialogue
          isVisible={showCancelTransactionErrorAlert}
          title={t('TransactionCancelError.title')}
          status="error"
          subTitle={`${sendCancelTransactionError}`}
          confirm={{
            label: t('TransactionCancelError.cancelButton'),
            action: () => handleDialogue({ type: 'error', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showCancelTransactionConfirmAlert, showCancelTransactionErrorAlert, sendCancelTransactionError],
  );
};

export default CancelTransactionDialogue;
